import noop from 'lodash/noop'
import { createContext } from 'react'

import { Product } from '@Generated/graphql'

export enum ActiveImageGestures {
  PINCH,
  ZOOM,
}

interface Slider {
  activeSlide: {
    key: number
    recalculate: boolean
  }
  goToNextSlide: (recalculate: boolean) => void
  goToPreviousSlide: (recalculate: boolean) => void
  isFullscreen: boolean
  isSwipedUp: boolean
  isVideoSlide: boolean
  setActiveSlide: ({ key: number, recalculate: boolean }) => void
  setSwipeUp: (value: boolean) => void
  slides: NonNullable<Product['assets']>
  toggleFullscreen: () => void
}

export const SliderContext = createContext<Slider>({
  activeSlide: {
    key: 0,
    recalculate: true,
  },
  goToNextSlide: noop,
  goToPreviousSlide: noop,
  setActiveSlide: noop,
  slides: [],
  toggleFullscreen: noop,
  isFullscreen: false,
  isVideoSlide: false,
  setSwipeUp: noop,
  isSwipedUp: false,
})
